import { Box, IconButton, makeStyles } from '@material-ui/core'
import { Add } from '@material-ui/icons'
import React, { useEffect, useState } from 'react'
import { AiFillDelete, AiFillEye } from 'react-icons/ai'
import { useCompanyConfig } from '../../hooks/CompanyConfiguration/useCompanyConfig'
import { isArray, uploadFilesToAws } from '../../shared/constants'
import CustomButton from '../CustomButton'
import CustomDialog from '../CustomDialog'
import { CustomInput } from '../CustomForm'
import CustomHeading from '../CustomHeading'
import HeadingWithCloseIcon from '../HeadingWithCloseIcon'
import ImageInputField from '../ImageInputField'
import CustomAddForm from '../version-4/MasterForms/CustomAddForm'
import CertificateDialog from './CertificateDialog'

const useStyles = makeStyles((theme) => ({
  button: {
    width: '200px',
    marginRight: '20px',
  },
  dialog: {
    minWidth: '800px',
  },
}))

export default function CertificateConfigDialog({ open, handleClose, form, certificateConfiguration = false }) {
  const [preview, setPreview] = useState(false)
  const [state, setstate] = useState({
    learningAcademyName: '',
    certificateHeader: '',
    certificateText: '',
    headerLogo: '',
    footerLogo: '',
    certified: '',

    // minSpecial:0,
  })
  console.log({ state })
  const classes = useStyles()
  //console.log('loggedUser : ')
  console.log({ state })
  const tempSignatures = [
    { name: '', designation: '', sign: '' },
    { name: '', designation: '', sign: '' },
  ]
  const [signatures, setSignatures] = useState(tempSignatures)
  const { updateCompanyAccount, getLoggedInUser, loggedUser } = useCompanyConfig()

  let handleChange = (i, e) => {
    let newFormValues = [...signatures]
    newFormValues[i][e.target.name] = e.target.name === 'sign' ? e.target.files : e.target.value
    setSignatures(newFormValues)
  }

  let addFormFields = () => {
    setSignatures([...signatures, tempSignatures])
  }

  let removeFormFields = (i) => {
    let newFormValues = [...signatures]
    newFormValues.splice(i, 1)
    setSignatures(newFormValues)
  }

  useEffect(() => {
    let tempArray = []
    if (certificateConfiguration) {
      setstate({ ...certificateConfiguration, headerLogo: [certificateConfiguration.headerLogo], footerLogo: [certificateConfiguration.footerLogo] })
      certificateConfiguration.signatory.map((val) => {
        tempArray.push({ ...val, sign: [val.sign] })
      })
      setSignatures(tempArray)
    }
  }, [certificateConfiguration])

  useEffect(() => {
    getLoggedInUser()
  }, [])
  //console.log('signatures : ', signatures)
  const inputfields = [
    {
      label: 'Learning Academy Name',
      value: state.learningAcademyName,
      name: 'learningAcademyName',
      grid: 12,
    },
    {
      label: 'Certification Header',
      value: state.certificateHeader,
      name: 'certificateHeader',
      grid: 12,
    },
    { label: 'Certificate Text', value: state.certificateText, name: 'certificateText', grid: 12 },
    { label: 'Certified Agency', value: state.certified, name: 'certified', grid: 4 },
    { label: 'Header Logo', value: state.headerLogo, name: 'headerLogo', grid: 4, type: 'IMAGE' },
    { label: 'Footer Logo', value: state.footerLogo, name: 'footerLogo', grid: 4, type: 'IMAGE' },
  ]

  const handleCertificateSubmit = async () => {
    console.log('SUBMITTING.........')
    let tempImage = []
    let tempHeaderLogo = state.headerLogo
    let tempFooterLogo = state.footerLogo

    if (!isArray(tempHeaderLogo)) tempHeaderLogo = await uploadFilesToAws(tempHeaderLogo)
    if (!isArray(tempFooterLogo)) tempFooterLogo = await uploadFilesToAws(tempFooterLogo)
    signatures.forEach(async (val, index) => {
      console.log('val : ', val)
      // if (!isArray(val.sign)) {
      let files = val.sign
      console.log('@ line 106')
      if (!isArray(files)) files = await uploadFilesToAws(val.sign)
      tempImage.push({ ...val, sign: files[0] })
      //console.log('tempArray : ', tempImage)
      if (index === 1) {
        updateCompanyAccount({ ...loggedUser, certificateConfiguration: { ...state, signatory: tempImage, headerLogo: tempHeaderLogo[0], footerLogo: tempFooterLogo[0] } })
        //console.log('SUBMIT')
      }
      // }
    })
  }

  return (
    <CustomDialog open={open} handleClose={handleClose} className={classes.dialog}>
      <HeadingWithCloseIcon heading={`${certificateConfiguration ? 'Edit' : 'Generate'} Certificate Configuration`} handleClose={handleClose} />
      <CustomAddForm state={state} setState={setstate} data={inputfields} />
      {signatures.map((val, index) => {
        return (
          <>
            <Box display="flex" justifyContent="space-between" marginTop="40px">
              <CustomHeading heading={`Signatory ${index + 1}`} />
              {index ? (
                <IconButton size="small" onClick={removeFormFields}>
                  <AiFillDelete style={{ color: 'red' }} />
                </IconButton>
              ) : null}
            </Box>
            <CustomInput label="Name" value={val.name} name="name" onChange={(e) => handleChange(index, e)} fullWidth />
            <CustomInput label="Designation" value={val.designation} name="designation" onChange={(e) => handleChange(index, e)} fullWidth />
            <ImageInputField label="Signature" value={val.sign} name="sign" onChange={(e) => handleChange(index, e)} fullWidth />
          </>
        )
      })}
      <Box display="flex" justifyContent="center" marginTop="30px">
        {signatures.length !== 2 ? (
          <Box>
            <CustomButton text="Add Signatory" handleSubmit={addFormFields} className={classes.button} icon={<Add />} />
          </Box>
        ) : (
          <Box>
            <CustomButton text="Preview" handleSubmit={() => setPreview(true)} className={classes.button} icon={<AiFillEye />} />
          </Box>
        )}
      </Box>

      <CertificateDialog open={preview} handleClose={() => setPreview(false)} certificate={state} signatures={signatures} handleCertificateSubmit={handleCertificateSubmit} />
    </CustomDialog>
  )
}
